import { useState } from 'react';

import { MENTION_STATUSES, MENTION_STATUS_LABELS } from '../utils/sentiment.js';

/** Status badge for sentiment mentions. Read-only span by default; an inline
 *  dropdown when `editable` (marketing_admin can change status). */
export default function MentionStatusBadge({ value, editable = false, onChange }) {
  const [busy, setBusy] = useState(false);
  const current = value || 'unreviewed';

  if (!editable) {
    return (
      <span className={`status-badge status-badge--${current}`}>
        {MENTION_STATUS_LABELS[current] || current}
      </span>
    );
  }

  async function handleChange(e) {
    const next = e.target.value;
    if (next === current) return;
    try {
      setBusy(true);
      await onChange(next);
    } finally {
      setBusy(false);
    }
  }

  return (
    <select
      className="status-dropdown"
      value={current}
      onChange={handleChange}
      disabled={busy}
      aria-label="Change status"
    >
      {MENTION_STATUSES.map((s) => (
        <option key={s.value} value={s.value}>
          {s.label}
        </option>
      ))}
    </select>
  );
}
